import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/5f45847157c596b0dd69fa68df90550f.png"
              alt="Aivina Intelligence Mark"
              className="h-10 w-10"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#capabilities"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#2FB8AC]' : 'text-white hover:text-[#2FB8AC]'
              }`}
            >
              Capabilities
            </a>
            <a
              href="#industries"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#2FB8AC]' : 'text-white hover:text-[#2FB8AC]'
              }`}
            >
              Industries
            </a>
            <a
              href="#services"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#2FB8AC]' : 'text-white hover:text-[#2FB8AC]'
              }`}
            >
              Services
            </a>
            <a
              href="#contact"
              className="bg-[#2FB8AC] text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-[#28a89d] transition-colors whitespace-nowrap cursor-pointer"
            >
              Schedule Call
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}